import { lazy } from 'react';

const Report = lazy(() => import('./Report'));

export default Report;
